import React, {useEffect, useState} from 'react';
import {
    useTheme,
    Box,
    Stack,
    Typography,
    TextField,
    Divider,
    Switch,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormControl,
    InputLabel,
    IconButton,
    Checkbox,
    Select,
    MenuItem
    // Fade,
    // IconButton,
    // Menu,
    // MenuItem,
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
// import EditIcon from '@mui/icons-material/Edit';
// import FormControl from '@mui/material/FormControl';
// import FormHelperText from '@mui/material/FormHelperText';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
// import InputBase from '@mui/material/InputBase';

// import MenuIcon from '@mui/icons-material/Menu';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import SearchIcon from '@mui/icons-material/Search';
// import DirectionsIcon from '@mui/icons-material/Directions';
import BillingService from "../services/BillingService";
// import {tokens} from "../../theme";

const ResetPassword = ({billingId, user, open, handleClose}) => {
    // const theme = useTheme();
    // const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(false);
    
    const descriptionElementRef = React.useRef(null);
    const [change, setChange] = useState(false)
    const [mobileTelephone, setMobileTelephone] = useState(user ? user.mobileTelephone : false)

    useEffect(() => {
        setLoading(false)
        setErrorMessage("")
        setChange(false)
        if (user) {
            if (user.mobile_telephone) {
                setMobileTelephone(user.mobile_telephone)
                setChange(true)
            }
            else {
                setMobileTelephone(false)
                setErrorMessage("Ошибка! В учетной записи не указан номер мобильного телефона.")
                setChange(false)
            }
        }
        else {
            setMobileTelephone(false)
            setErrorMessage("Ошибка! В учетной записи не указан номер мобильного телефона.")
        }
        setLoading(true)
    }, [user])

    // save
    const [errorMessage, setErrorMessage] = useState("")
    const handleSave = async () => {
        setLoading(false)
        setErrorMessage("")
        if (errorMessage) {
            setErrorMessage("Error")
            setLoading(true)
            return
        }
        try {
            const response = await BillingService.billing_user_reset_password(billingId, user.user_id);
            handleClose()
        } catch (e) {
            console.log(e);
            setErrorMessage("Error reset password.")
        } finally {
            setLoading(true)
        }
    }

    return (
        <Box>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={'body'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    Сброс пароля
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        // p={5}
                    >
                        {!loading && <LinearProgress /> }
                        {errorMessage && <Typography>{errorMessage}</Typography>}
                        <Stack spacing={3}>
                            {/* <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', }}
                            > */}
                                {change &&
                                    <Typography>
                                        Внимание! Будет сгенерирован и установлен новый пароль для личного кабинета. Ссылка на личный кабинет, 
                                        логин и пароль будет отправлены в виде СМС на номер {mobileTelephone}
                                    </Typography>
                                }
                            {/* </Paper> */}
                        </Stack>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Отмена
                    </Button>
                    {change && (
                        <Button onClick={handleSave} color="primary">
                            Сбросить
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
}
export default ResetPassword;